// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"6223ca6e","703":"72b7bf24","715":"0e61f22b","840":"a9dc18c7"}[chunkId] + ".chunk.js";
};